export function getVendor() {
  const n: any = navigator;

  return `${n.buildID},${n.product},${n.productSub},${n.vendor},${n.vendorSub}`;
}
